export var QuickSelectionWidgetVariantTypes;
(function (QuickSelectionWidgetVariantTypes) {
  QuickSelectionWidgetVariantTypes["SINGLE_LINE"] = "singleLine";
  QuickSelectionWidgetVariantTypes["MULTI_LINE"] = "multiLine";
})(QuickSelectionWidgetVariantTypes || (QuickSelectionWidgetVariantTypes = {}));